const MAX_WORDS = 4;
// Built with RegExp: the web TypeScript target predates the `u` flag in literals.
const EDGE_PUNCTUATION = new RegExp('^[^\\p{L}\\p{N}]+|[^\\p{L}\\p{N}]+$', 'gu');
const LETTER = new RegExp('\\p{L}', 'u');
const MAX_CONTEXT = 300;

/** A selection worth saving as a word: one to four words with a letter in them. */
export function savableWord(text: string): string | null {
  const word = text.replace(/\s+/g, ' ').trim().replace(EDGE_PUNCTUATION, '');
  if (!word || word.length > 60 || !LETTER.test(word)) return null;
  return word.split(' ').length <= MAX_WORDS ? word : null;
}

/** The sentence around `word` in `text`, so the definition matches that sense. */
export function sentenceAround(text: string, word: string): string {
  const flat = text.replace(/\s+/g, ' ').trim();
  const at = flat.toLowerCase().indexOf(word.toLowerCase());
  if (at < 0) return flat.slice(0, MAX_CONTEXT);
  const before = flat.slice(0, at);
  const start = Math.max(before.lastIndexOf('. '), before.lastIndexOf('? '), before.lastIndexOf('! '));
  const rest = flat.slice(at);
  const endMatch = rest.search(/[.?!](\s|$)/);
  const end = endMatch < 0 ? flat.length : at + endMatch + 1;
  return flat.slice(start < 0 ? 0 : start + 2, end).trim().slice(0, MAX_CONTEXT);
}
